<template>
  <RF-Aba :cpntButtons='buttons' class="df-config"></RF-Aba>
</template>

<style>
  .df-config > table {
    width: 100%;
  }
</style>

<script>
  export default {
    components: {
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba.vue')
    },
    data: function () {
      return {
        buttons: []
      }
    },
    mounted: function () {
      // RESETA O MENU EXISTENTE
      this.buttons = []

      // ADICIONA A ABA CADASTRO
      if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 25, 23, 20 ], 'or', null, null, null, null, false) === true) {
        this.buttons.push({ nome: 'Emissor', router: this.$router.resolve({ name: 'df_config_emissor', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'df_config_emissor' ] })
      }

      // ADICIONA A ABA LOGOTIPO
      if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 31 ], null, [ 55 ], null, [ 900 ], null, false) === true) {
        this.buttons.push({ nome: 'DF Recebidos', router: this.$router.resolve({ name: 'df_config_recebidos', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'df_config_recebidos' ] })        
      }

      // VERIFICA SE EXISTE ALGUM BOTÃO
      if (this.buttons.length === 0) {
        this.$router.push({ name: 'erro_perfil' })
      } else if (this.$route.name === 'df_config') {
        this.$router.push(this.buttons[0].router)
      }
    }
  }
</script>
